import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { ReportingService } from '../reporting.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

import { LoginService } from '../../login/login.service';
import { YearService } from '../../../shared-components/year/year.service';
import { LoginSettings } from '../../login/LoginSetting.model';

import { Report } from '../models/report.model';
import { ReportFolder } from '../models/report-folder.model';
import { ReportParametersComponent } from '../parameters/report-parameters.component';
import { ReportSettingsFoldersComponent } from '../report-settings/report-settings.folders.component';
import { ReportSnapshotsComponent } from '../report-snapshots/report-snapshots.component';
import { TylerMatTableDataSource } from '../../../shared-components/angular-material/extended.class';

import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { detailExpand } from '../../../shared-components/angular-material/mat-animations';
import { ReportSettingsAutoRunComponent } from '../report-settings/report-settings-autorun.component';
import { ReportOptionsComponent } from '../definitions/report-options.component';
import { ReportAutoRunMessageComponent } from '../report-settings/report-autorun-message.component';
import { ReportV9 } from '../models/report-v9.model';
import { ManualEntryRostersComponent } from '../V9/manual-entry-rosters/manual-entry-rosters.component';
import { ClassListAllComponent } from '../V9/class-list-all/class-list-all.component';
import { TeacherSummaryPreviewComponent } from '../V9/teacher-summary-preview/teacher-summary-preview.component';
import { GradebookProgessReportComponent } from '../V9/gradebook-progress-report/gradebook-progress-report.component';
import { ClassListAllAttendanceNotMarkedComponent } from '../V9/class-list-all-attendance-not-marked/class-list-all-attendance-not-marked.component';
import { AttendanceHistoryByClassComponent } from '../V9/attendance-history-by-class/attendance-history-by-class.component'; // ONE-4251
import { GradebookAssignmentsByStandardComponent } from '../V9/gradebook-assignments-by-standard/gradebook-assignments-by-standard.component';
import { v9ReportParameterName } from '../reporting.service';
import { ReportTemplateClassListComponent } from '../V9/report-template-class-list/report-template-class-list.component';
import { GradebookByClassGridComponent } from '../V9/gradebook-by-class-grid/gradebook-by-class-grid.component';
import { System } from '../../../shared-components/System';
import { V9ReportParametersComponent } from '../V9/parameters/v9-report-parameters.component';

@AutoUnsubscribe()
@Component({
    selector: 'myReports',
    templateUrl: './my-reports.component.html',
    styleUrls: ['./my-reports.component.css'],
    // Animation for when the detail row is expanded or collapsed
    animations: [detailExpand]
    // entryComponents: [
    //     ReportParametersComponent
    //     ]
})

export class MyReportsComponent implements OnInit, OnDestroy {

    @Input() expandAllFolders: boolean;
    @Input() refreshedReportFolders: boolean;

    // @Output() public expandAllEvent = new EventEmitter(); // to send to report settings component

    loginSettings: LoginSettings;
    yearService: YearService;
    utilizeDistributebyEmail: boolean;
    allowAutoRunReport: boolean;
    angularMatData = new TylerMatTableDataSource;
    columnsToDisplay: string[] = ['More', 'ReportFolderName'];
    columnsToDisplayDetailRow: string[] = ['ReportFolderName', 'ReportName', 'ReportSnapshotsLength', 'AutoRun', 'Actions'];
    useReportDefinitions: boolean;
    reportOptionsDialogRef: MatDialogRef<ReportOptionsComponent>;
    manualEntryRostersDialogRef: MatDialogRef<ManualEntryRostersComponent>;
    ClassListAllDialogRef: MatDialogRef<ClassListAllComponent>;
    ClassListAllAttendanceNotMarkedDialogRef: MatDialogRef<ClassListAllAttendanceNotMarkedComponent>;
    TeacherSummaryPreviewDialogRef: MatDialogRef<TeacherSummaryPreviewComponent>;
    GradebookProgessReportDialogRef: MatDialogRef<GradebookProgessReportComponent>;
    attendanceHistoryByClassDialogRef: MatDialogRef<AttendanceHistoryByClassComponent>; // ONE-4251
    gradebookAssignmentsByStandardDialogRef: MatDialogRef<GradebookAssignmentsByStandardComponent>; // ONE-4254
    reportTemplateClassListDialogRef: MatDialogRef<ReportTemplateClassListComponent>;
    gradebookByClassGridDialogRef: MatDialogRef<GradebookByClassGridComponent>;
    isForSchedule: boolean;

    private _showNoFoldersMessage: boolean;

    get showNoFoldersMessage(): boolean {
        return this._showNoFoldersMessage;
        // return this.reportingService.showNoFoldersMessage;
    }

    set showNoFoldersMessage(value: boolean) {
        this._showNoFoldersMessage = value;
        this.reportingService.showNoFoldersMessage = value;
    }
    // expandedRows: number[] = [];
    ReportFolders: ReportFolder[] = [];
    Reports: ReportV9[] = [];
    ReportModules: ReportV9[] = [];
    // rowDetailExpand: [number[], boolean];


    SelectedReport: Report;
    reportParametersDialogRef: MatDialogRef<ReportParametersComponent>;
    reportSettingsDialogRef: MatDialogRef<ReportSettingsFoldersComponent>;
    reportSettingsAutoRunDialogRef: MatDialogRef<ReportSettingsAutoRunComponent>;
    reportSnapshotsDialogRef: MatDialogRef<ReportSnapshotsComponent>;
    reportAutoRunMessageDialogRef: MatDialogRef<ReportAutoRunMessageComponent>;

    // enums
    v9parameterName = v9ReportParameterName; // parameter name enum

    tylerMatData = new TylerMatTableDataSource();
    isExpandAll = false;
    columnDisplayV9 = ['More', 'Description'];

    constructor(
        private reportingService: ReportingService,
        private loginService: LoginService,
        private reportParametersDialog: MatDialog,
        private reportSettingsDialog: MatDialog,
        private reportSettingsAutoRunDialog: MatDialog,
        private reportSnapshotsDialog: MatDialog,
        private reportOptionsDialog: MatDialog,
        private reportAutoRunMessageDialog: MatDialog,
        private manualEntryRostersDialog: MatDialog,
        private classListAllDialog: MatDialog,
        private classListAllAttendanceNotMarkedDialog: MatDialog,
        private TeacherSummaryPreviewDialog: MatDialog,
        private ReportCardDialog: MatDialog,
        private attendanceHistoryByClassDialog: MatDialog, // ONE-4251
        private gradebookAssignmentsByStandardDialog: MatDialog, // ONE-4254
        private dialog: MatDialog

    ) {
        this.loginSettings = loginService.LoginSettings;
        this.allowAutoRunReport = this.reportingService.allowAutoRunReport;
        this.angularMatData = new TylerMatTableDataSource(this.ReportFolders);
        this.useReportDefinitions = reportingService.useReportDefinitions;
        this.isForSchedule = this.reportingService.isForSchedule;

        // this.utilizeDistributebyEmail = this.loginSettings.UtilizeDistributebyEmail;

        // if (this.reportingService.inDebugMode) {
        //     console.log('MyReportsComponent constructor');
        //     console.log(this.reportingService.showNoFoldersMessage);
        // }

        // this.getMyReportFolders();

    } // end constructor

    ngOnInit() {
        if (this.loginSettings.V10 == true) {
            this.getMyReportFolders();
        } else {
            this.getMyV9Reports();
        }
    }

    ngOnDestroy() {
        // if (this.reportingService.inDebugMode) {
        //     console.log('MyReportsComponent => ngOnDestroy');
        // }
    }

    loadReportData(): void {
        // load data into Angular Material table
        this.angularMatData.data = this.ReportFolders;

        // default to expand all folders
        this.angularMatData.expandAll(true);
        // if (this.reportingService.inDebugMode) {
        //     console.log('loadReportData()');
        // }
    }


    expandAllFoldersClick(expandAll: boolean) {
        this.expandAllFolders = expandAll;
        this.expandAllRows(-1, expandAll);

        // send emitted property to the Angular Material function
        this.expandAll(expandAll);


        // console.log('expandAllFoldersClick: ' + expandAll);
        // console.log(this.ReportFolders);
        // console.log('expandAllFoldersClick -- END');

    }

    getMyReportFolders(): void {
        this.reportingService.getMyReportFolders().subscribe(reportFolders => {
            this.ReportFolders = reportFolders;
            this.reportingService.ReportFolders = this.ReportFolders;

            if (this.ReportFolders.length > 0) {
                this.showNoFoldersMessage = false;
                this.reportingService.showNoFoldersMessage = false;
            }
            else {
                this.showNoFoldersMessage = true;
                this.reportingService.showNoFoldersMessage = true;
            }

            // this.showNoFoldersMessage = this.reportingService.showNoFoldersMessage;

            this.expandAllRows(-1, true);

            this.loadReportData();
            // if (this.reportingService.inDebugMode) {
            //     console.log('MyReportsComponent =>  angularMatData');
            //     console.log(this.angularMatData);
            //     console.log('MyReportsComponent =>  SelectFolders length: ' + this.ReportFolders.length);
            //     console.log(this.ReportFolders);
            //     console.log(this.showNoFoldersMessage);
            // }




        });


        //  this.showNoFoldersMessage = this.reportingService.showNoFoldersMessage;
    }

    getMyV9Reports(): void {
        this.reportingService.getV9Reports('TeacherMenu').subscribe(rpt => {

            if (this.reportingService.inDebugMode) {
                console.log(rpt);
            }

            // remove progress report for now, can only get to it from the gradebook
            let i = 0;
            rpt.forEach(f => {
                const ri = f.ReportsList.filter(r => r.ReportName != 'GradeBookProgressReport');
                if (i >= 0) {
                    rpt[i].ReportsList = System.convert<ReportV9[]>(ri, new Array<ReportV9>());
                }
                i++;
            }
            );

            this.Reports = System.convert<ReportV9[]>(rpt, new Array<ReportV9>());

            const IsReportsList: boolean = rpt.filter(x => x.ReportsList.length > 0).length > 0;
            if (IsReportsList == true) {
                this.ReportModules = rpt.filter(x => x.ParentId == 0);
            } else {
                this.Reports = [];
                const obj = new ReportV9();
                obj.Id = 0;
                obj.ReportsList = rpt;
                this.Reports.push(obj);
            }

            this.tylerMatData.data = this.Reports;
        });
    }

    expandAllRows(folderID: number, expandAll: boolean) {

        if (folderID == -1) {
            // -1 is ALL folders
            for (let f = 0; f < this.ReportFolders.length; f++) {
                this.ReportFolders[f].IsDetailRowExpanded = expandAll;

                // this.expandedRows.push(this.ReportFolders[f].Id);
            }
            // if (this.reportingService.inDebugMode) {
            //     console.log('expandedRows: ' + this. expandedRows);
            // }
        }

    }

    expandCollapseFolder(reportFolder: ReportFolder) {
        // if (this.reportingService.inDebugMode) {
        //     console.log('MyReportsComponent =>  expandCollapseFolder()');
        //     console.log(reportFolder);
        // }
        reportFolder.IsDetailRowExpanded = !reportFolder.IsDetailRowExpanded;
        // this.reportingService.ReportFolders[reportFolder.Id].IsDetailRowExpanded = reportFolder.IsDetailRowExpanded;
        // this.ReportFolders[folderID].IsDetailRowExpanded = !this.ReportFolders[folderID].IsDetailRowExpanded;

    }

    reportClicked(report) {
        // if (this.reportingService.inDebugMode) {
        //     console.log('MyReportsComponent =>  reportClicked(' + report.Name + ', IsSysGen=' + report.IsSysGen + ')');
        // }

        this.reportingService.isFromMenu = false;

        this.reportingService.getReportParameters(-1, report).subscribe(selectedReport => {

            // if (this.reportingService.inDebugMode) {
            //     console.log(selectedReport);
            // }

            this.reportingService.SelectedReport = selectedReport;
            this.openReportParametersWindow();

        });

    }


    openReportParametersWindow() {
        this.reportParametersDialogRef = this.reportParametersDialog.open(ReportParametersComponent, {
            panelClass: 'tyl-mat-dialog',
            disableClose: true
        });

        // this.reportsDialogRef.beforeClose().subscribe(result => {
        //  console.log('shared/HeaderComponent =>reportsDialogRef.beforeClose()');
        // });


        this.reportParametersDialogRef.afterClosed().subscribe(result => {

            // if (this.reportingService.inDebugMode) {
            //     console.log('myReportsComponent =>reportParametersDialogRef.afterClosed()');
            //     console.log('reportService.isForSchedule: ' + this.reportingService.isForSchedule.toString());
            //     console.log('this.isForSchedule: ' + this.isForSchedule.toString());
            // }

            if (result > '' && this.isForSchedule == true) {
                this.getMyReportFolders();

            }
        });


    }



    reportSettingsClick(report: Report) {
        this.reportingService.SelectedReport = report;
        this.reportingService.ReportFolders = this.ReportFolders;
        this.reportSettingsDialogRef = this.reportSettingsDialog.open(ReportSettingsFoldersComponent, {
            panelClass: 'tyl-mat-dialog',
            disableClose: true
        });

        this.reportSettingsDialogRef.afterClosed().subscribe(result => {

            // if (this.reportingService.inDebugMode) {
            //     console.log('myReportsComponent =>reportSettingsDialogRef.afterClosed()');
            // }

            if (result > '') {
                this.getMyReportFolders();
            }

        });
    }

    autorunSettingsClick(report: Report) {

        this.reportingService.SelectedReport = report;
        this.reportingService.ReportFolders = this.ReportFolders;
        this.reportingService.isForSchedule = true;
        this.isForSchedule = true;

        // check that  allowAutoRunReport (system) and AllowAutoRun(report and that report is in a folder
        // if not, show message
        if (this.allowAutoRunReport == false || report.AllowAutoRun == false || report.ReportFolder == '') {
            this.reportAutoRunMessageDialogRef = this.reportAutoRunMessageDialog.open(ReportAutoRunMessageComponent, {
                panelClass: 'tyl-mat-dialog',
                disableClose: true
            });
            return;
        }
        // call report params load and pop up and show autorun setting within

        // we will need to determine if this is a new or existing autorun when populating parameters

        let isExistingAutorun = false;
        if (report.AutoRunSchedule_ID > 0) {
            // pull saved parameters
            isExistingAutorun = true;
        }

        this.reportingService.getReportParameters(-1, report, isExistingAutorun).subscribe(selectedReport => {

            // if (this.reportingService.inDebugMode) {
            //     console.log(selectedReport);
            // }

            this.reportingService.SelectedReport = selectedReport;
            this.openReportParametersWindow();

        });


        // this.reportParametersDialogRef.afterClosed().subscribe(result => {

        //     if (this.reportingService.inDebugMode) {
        //         console.log('myReportsComponent =>reportParametersDialogRef.afterClosed()');
        //     }

        //     if (result > '') {
        //         this.getMyReportFolders();
        //     }
        // });

        // this.reportSettingsAutoRunDialogRef = this.reportSettingsAutoRunDialog.open(ReportSettingsAutoRunComponent, {
        //     panelClass: 'tyl-mat-dialog',
        //     disableClose: true
        // });

        // this.reportSettingsAutoRunDialogRef.afterClosed().subscribe(result => {

        //     if (this.reportingService.inDebugMode) {
        //         console.log('myReportsComponent =>reportSettingsAutoRunDialogRef.afterClosed()');
        //     }

        //     if (result > '') {
        //         this.getMyReportFolders();
        //     }

        // });

    }

    reportOptionsClick(report: Report) {
        this.reportingService.SelectedReport = report;
        this.reportingService.isFromMenu = true;
        // this.reportingService.ReportFolders = this.myReportFolders;

        this.reportOptionsDialogRef = this.reportOptionsDialog.open(ReportOptionsComponent, {
            panelClass: 'tyl-mat-dialog',
            disableClose: true
        });

        this.reportOptionsDialogRef.afterClosed().subscribe(result => {

            // if (this.reportingService.inDebugMode) {
            //     console.log('AllReportsComponent =>reportOptionsDialogRef.afterClosed()');
            // }

            // if (result > '') {
            //   this.getMyReportFolders();
            // }

        });

    }

    reportSnapshotsClick(report: Report, folderId: number) {

        // console.log('HEY, IN reportSnapshotsClick()');

        // if (this.reportingService.inDebugMode) {
        //     console.log('reportSnapshotsClick()');
        //     console.log(this.ReportFolders);
        //     console.log('this.reportingService.ReportFolders');
        //     console.log(this.reportingService.ReportFolders);
        // }

        this.reportingService.SelectedReport = report;
        this.reportingService.ReportFolders = this.ReportFolders;
        this.reportingService.selectedReportFolderId = folderId;
        this.reportSnapshotsDialogRef = this.reportSnapshotsDialog.open(ReportSnapshotsComponent, {
            panelClass: 'tyl-mat-dialog',
            disableClose: true
        });

        this.reportSnapshotsDialogRef.afterClosed().subscribe(result => {

            // if (this.reportingService.inDebugMode) {
            //     console.log('myReportsComponent =>reportSnapshotsDialogRef.afterClosed()');
            // }

            if (result == true) {
                this.getMyReportFolders();
            }

        });
    }

    reportSettingsV9Click(rpt) {
        this.reportingService.SelectedReport = rpt;

        if (this.reportingService.inDebugMode) {
            console.log('REPORT CLICKED!');
            console.log(rpt);
        }

        if (rpt.ReportName == 'ManualEntryRosters') {
            this.manualEntryRostersDialogRef = this.manualEntryRostersDialog.open(ManualEntryRostersComponent, {
                panelClass: 'tyl-mat-dialog',
                disableClose: true,
                data: { Report: rpt },
                minWidth: '85vw',
                maxWidth: '100vw',
                minHeight: '85vh',
                maxHeight: '100vh'
            });
        }
        else if (rpt.ReportName == 'CreateCurrentDayAttendanceByClass' && rpt.ReportTitle == 'Class List - All') {
            this.ClassListAllDialogRef = this.classListAllDialog.open(ClassListAllComponent, {
                panelClass: 'tyl-mat-dialog',
                disableClose: true,
                data: { Report: rpt },
                minWidth: '85vw',
                maxWidth: '100vw',
                minHeight: '85vh',
                maxHeight: '100vh'
            });
        }
        else if (rpt.ReportName == 'CreateCurrentDayAttendanceByClass' && rpt.ReportTitle == 'Class List - Attendance Not Marked') {
            this.ClassListAllAttendanceNotMarkedDialogRef = this.classListAllAttendanceNotMarkedDialog.open(ClassListAllAttendanceNotMarkedComponent, {
                panelClass: 'tyl-mat-dialog',
                disableClose: true,
                data: { Report: rpt },
                minWidth: '85vw',
                maxWidth: '100vw',
                minHeight: '85vh',
                maxHeight: '100vh'
            });
        }
        else if (rpt.ReportName == 'AttendancePreviewByTeacher') {
            this.TeacherSummaryPreviewDialogRef = this.TeacherSummaryPreviewDialog.open(TeacherSummaryPreviewComponent, {
                panelClass: 'tyl-mat-dialog',
                disableClose: true,
                data: { Report: rpt },
                minWidth: '85vw',
                maxWidth: '100vw',
                minHeight: '85vh',
                maxHeight: '100vh'
            });
        }
        else if (rpt.ReportName == 'CreateAttendanceHistoryByClass' || rpt.Description == 'Attendance History by Class') {
            this.attendanceHistoryByClassDialogRef = this.attendanceHistoryByClassDialog.open(AttendanceHistoryByClassComponent, {
                panelClass: 'tyl-mat-dialog',
                disableClose: true,
                data: { Report: rpt },
                minWidth: '85vw',
                maxWidth: '100vw',
                minHeight: '85vh',
                maxHeight: '100vh'
            });
        }
        else if (rpt.ReportName == 'GradeCommentList') {

            /*

            Public Class pub_clsReportCardCommentParameters
                'Connection String
                Public strConnectionString As String = ""
                'Report Parameters
                Public strReportOutputFile As String = ""
                Public strReportOutputFolderUNC As String = ""
                'Option Based Parameters
                Public strReportDate As String = ""
                Public strReportSiteHeader As String = ""
                Public strReportTitle As String = ""
                Public strSiteYearCode As String = ""
                Public intSiteYearId As Integer = 0
                Public strStudentSelectionStatus As String = ""
                Public strStudentIds As String = ""
                Public blnPageBreakAfterEachStudent As Boolean = False
            End Class
            */

            const reportType = 1;
            const reportTitle = 'Report Card Comment List';
            const reportName = 'GradeCommentList'; // 'CreateReportCardCommentsReport'; // 'GradeCommentList';

            const param = [];
            /* eslint-disable no-bitwise */
            this.reportingService.addCoreParametersV9
                (
                    param,
                    reportTitle,
                    reportType,
                    // this.v9parameterName.strReportSiteAddress |
                    this.v9parameterName.strReportDate |
                    this.v9parameterName.strReportSiteHeader |
                    this.v9parameterName.strReportTitle |
                    this.v9parameterName.strSiteYearCode |
                    this.v9parameterName.lngSiteYearId
                    // this.v9parameterName.intSiteYearId |
                    // this.v9parameterName.strOutputFile_NOFILE
                    // this.v9parameterName.bytReportType ||
                    // this.v9parameterName.strOutputFile_NOFILE

                );
            /* eslint-enable no-bitwise */

            // Public strStudentSelectionStatus As String = ""
            // Public strStudentIds As String = ""
            // Public blnPageBreakAfterEachStudent As Boolean = False

            const parameters = [];
            const stringifiedParameters = JSON.stringify(param);
            parameters.push(stringifiedParameters);

            if (this.reportingService.inDebugMode) {
                console.log('REPORT PARAMETERS TO BE RUN:');
                console.log(param);
                console.log('REPORT PARAMETERS STRINGIFIED:');
                console.log(stringifiedParameters);
            }

            this.reportingService.openStudentAttachmentReport(0, reportName, '', '', '', parameters, reportType);

        }
        else if (rpt.ReportName == 'CreateGradebookAssignmentsByObjectiveReport') {
            this.gradebookAssignmentsByStandardDialogRef = this.gradebookAssignmentsByStandardDialog.open(GradebookAssignmentsByStandardComponent, {
                panelClass: 'tyl-mat-dialog',
                disableClose: true,
                data: { Report: rpt },
                minWidth: '85vw',
                maxWidth: '100vw',
                minHeight: '85vh',
                maxHeight: '100vh'
            });
        }
        else {
            const v9ReportParametersDialogRef = this.dialog.open(V9ReportParametersComponent, {
                panelClass: 'tyl-mat-dialog',
                disableClose: true,
                data: { Report: rpt },
                minWidth: '50vw',
                maxWidth: '100vw',
                minHeight: '50vh',
                maxHeight: '100vh'
            });

            v9ReportParametersDialogRef.componentInstance.selectedReport = JSON.parse(JSON.stringify(rpt));

            v9ReportParametersDialogRef.afterClosed().subscribe(result => {
                if (result != undefined) {
                    this.getMyV9Reports();
                }
            });
        }
    } // end reportSettingsV9Click


    isEven(folderId) {
        return (folderId % 2) === 0;
    }


    closeClick() {

        // this.reportingService.close();
    }

    // ----------Angular Material------------------------------------
    // These methods are used to allow calls to the TylerMatTableDataSource methods from the html
    toggleExpanded(row: any) {
        // Toggles row between expanded and collapsed
        if (this.loginSettings.V10 == true) {
            this.angularMatData.toggleExpanded(row);
        }
        else {
            this.tylerMatData.toggleExpanded(row);
        }
    }

    checkExpanded(row: any): boolean {
        // Return true if expanded and false if collapsed
        if (this.loginSettings.V10 == true) {
            return this.angularMatData.checkExpanded(row);
        } else {
            return this.tylerMatData.checkExpanded(row);
        }
    }

    expandAll(expand: boolean) {
        //  Expand or collapse all rows
        //  true => expand all    false => collapse all
        this.angularMatData.expandAll(expand);
    }

    rowKeyPress(event: KeyboardEvent, row: any) {
        if (this.loginService.LoginSettings.V10 == true) {
            this.angularMatData.rowKeyPress(event, row);
        } else {
            this.tylerMatData.rowKeyPress(event, row);
        }

    }

    expandAllV9() {
        this.isExpandAll = !this.isExpandAll;
        for (const row of this.tylerMatData.data) {
            row.detailRow = this.isExpandAll;
        }
    }

} // end export class MyReports




